/*eslint-disable*/
import { createSlice } from '@reduxjs/toolkit'

// actions
import { getUsers } from '../actions/users'

const initialState = {
    status: 'idle',
    error: null,
    filteredUsers: [],
}

export const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
      resetFilteredUsers: (state) => {
        state.filteredUsers = []
      },
    },
    extraReducers(builder) {
      builder
        .addCase(getUsers.pending, (state) => {
          state.status = 'loading'
          state.error = undefined
        })
        .addCase(getUsers.fulfilled, (state, action) => {
          state.status = 'succeeded'
          state.error = undefined
          state.filteredUsers = [...action.payload.resources]
        })
        .addCase(getUsers.rejected, (state, action) => {
          state.status = 'failed'
          state.error = action.error.message
        })
    }
  })

  export const { resetFilteredUsers } = usersSlice.actions

  export default usersSlice.reducer;

